module.exports = __webpack_public_path__ + "static/img/大雪转暴雪.90850534.svg";